var React = require('react');

function IconDesktop (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M0 0H24V24H0z","key":0}),React.createElement("path",{"fill":"#9e9e9e","d":"M22.818 2H3.182A2.2 2.2 0 0 0 1 4.2v13.2a2.2 2.2 0 0 0 2.182 2.2h7.636l-2.182 3.3V24h8.727v-1.1l-2.182-3.3h7.636A2.2 2.2 0 0 0 25 17.4V4.2A2.2 2.2 0 0 0 22.818 2zm0 13.2H3.182v-11h19.636z","transform":"translate(-1 -1)","key":1})]);
}

IconDesktop.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconDesktop;

IconDesktop.default = IconDesktop;
